const INFO = {
	main: {
		title: "M.Parracho",
		name: "Matheus Ramos Parracho",
		email: "mramosparracho@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		//twitter: "https://twitter.com/",
		github: "https://github.com/mathparracho",
		linkedin: "https://www.linkedin.com/in/matheusparracho",
		medium: "https://medium.com/@mathparracho",
		kaggle: "https://www.kaggle.com/matheusparracho",
		//instagram: "https://instagram.com/",
		//stackoverflow: "https://stackoverflow.com/",
		//facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Hello, I am Matheus. Nice to meet you!",
		description:
			"Here you found a guy with an insatiable curiosity for discovering new technological paradigms in AI. Specialized in Computer Vision, Forecasting, and Probabilistic Models, I hold a Master’s from IP Paris in Computer Vision and am in the final stretch of my studies at the Federal University of Rio de Janeiro.",
	},

	about: {
		title: "Who I Am, and What I am Building",
	description: (
	<>
		I am an AI Researcher and Engineer specializing in Computer Vision and Deep Learning, holding a Master’s degree in Computer Vision from Télécom SudParis (Institut Polytechnique de Paris) and completing my Bachelor’s in Electronics and Computer Engineering at UFRJ.<br />
		Passionate about Neural Networks, I have experience reaching multiple domains — from medical imaging and signal processing to embedded systems and software development — integrating both research and engineering perspectives.<br />
		My work bridges neural network design, representation learning, and practical system development, uniting theory and application across diverse fields.<br />
		<br />

		<p style={{ fontSize: '1.4em', fontWeight: 'bold' }}>Experience</p>
		<ul>
		<li>
			<strong>AI Researcher</strong> — Multimedia Signals and Telecommunications Laboratory (SMT), UFRJ, Brazil<br />
			<em>Sept 2024 – Present</em><br />
			• Working on the <strong>Open-Source 3W Framework Petrobras Project</strong>, an open toolkit for time series analysis focused on detecting undesirable events in offshore oil wells.<br />
			• Researching <strong>contrastive and representation learning methods</strong> for signal and signature matching using PyTorch.<br />
			• Developed novel architectures for offline signature verification, analyzing augmentation, optimization, and inference procedures.<br />
			• Technical stack: PyTorch, Git, Linux, NumPy, and custom data processing pipelines.<br />
		</li>

		<li>
			<strong>AI Research Intern</strong> — GE Healthcare, Paris Region<br />
			<em>Jan 2024 – July 2024</em><br />
			• Conducted research in medical imaging, focusing on mammography and AI-driven diagnosis systems.<br />
			• Designed, trained, and optimized deep learning models.<br />
			• Authored a 67-page technical report graded 19/20, stored internally by GE for confidentiality.<br />
			• Explored augmentation techniques to improve robustness and generalization on large-scale medical datasets.<br />
			<figure style={{ marginTop: 10 }}>
			<img
				src="/team_ge.jpg"
				alt="GE Healthcare football team - Paris"
				style={{ width: '80%', borderRadius: '12px', marginTop: '10px', boxShadow: '0 6px 18px rgba(0,0,0,0.18)' }}
			/>
			<figcaption style={{ fontSize: '0.9em', color: '#555', marginTop: 6 }}>Team bonding beyond research — GE Healthcare’s mammography football match, Paris.</figcaption>
			</figure>
		</li>

		<li>
			<strong>Software & Electronics Researcher</strong> — Waves and Currents Laboratory (LOC), UFRJ, Brazil<br />
			<em>June 2022 – Nov 2022</em><br />
			• Worked on embedded systems for real offshore stabilization projects.<br />
			• Implemented control and sensor systems using C++, serial protocols, and PID control algorithms.<br />
			• Focused on digital electronics, actuators, and energy distribution for maritime applications.<br />
		</li>

		<li>
			<strong>Avionics Engineer / Manager</strong> — Minerva Rockets Aerospace Research Group, UFRJ, Brazil<br />
			<em>July 2021 – Aug 2022</em><br />
			• Managed avionics and telemetry systems for rockets competing at the <strong>Latin American Space Challenge (LASC 2022)</strong>.<br />
			• Developed low-level embedded systems for data acquisition and recovery operations during flight.<br />
			• Specialized in microcontrollers, circuits, sensors, and actuator control.<br />
			<div
			style={{
				display: 'grid',
				gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
				gap: '12px',
				marginTop: '12px'
			}}
			>
			<img
				src="/rockets_1.png"
				alt="Minerva Rockets members holding rocket"
				style={{ width: '100%', borderRadius: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.18)' }}
			/>
			<img
				src="/rockets_2.png"
				alt="Full Minerva Rockets team posing with rocket"
				style={{ width: '100%', borderRadius: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.18)' }}
			/>
			</div>
		</li>

		<li>
			<strong>Data Engineer</strong> — Scoutfy, São Paulo, Brazil<br />
			<em>Nov 2020 – July 2021</em><br />
			• Designed APIs in Node.js and Python integrated with SQL Server and AWS for analytics automation.<br />
			• Worked on backend and data pipelines (Pandas, NumPy, Scikit-learn) for structured data processing.<br />
			• Implemented dashboards, web scraping modules, and server deployment (Linux + AWS).<br />
		</li>

		</ul>

		<p style={{ fontSize: '1.4em', fontWeight: 'bold' }}>Entrepreneurship & Parallel Projects</p>
		<ul>
		<li>
			<strong>Parracho Labs (parracholabs.com)</strong> — Independent AI consultancy company for Computer Vision and Predictive Systems.<br />
			• R&D services in stochastic temporal modeling, forecasting, and anomaly detection.<br />
			• Developing an offline signature verification system based on hybrid deep learning and handcrafted features.<br />
			• Building financial forecasting models using <strong>TCN</strong> and <strong>WaveNet</strong> with uncertainty estimation.<br />
			• Created OCR pipelines, data dashboards, and custom PyTorch frameworks.<br />
		</li>
		<li>
		<strong>Semppo</strong> — Co-Founder and CTO (supported by Google for Startups)<br />
		• Developed a mobile safety platform enabling anonymous emergency reporting and real-time alerts to nearby users.<br />
		• Led mobile design (React Native + Expo) and backend integration (Firebase + Node.js), ensuring secure geolocation and cloud synchronization.<br />
		• Project selected and supported by Google for Startups for its social impact and innovative architecture.<br />
		</li>

		<li>
		<strong>MaskUid</strong> — Privacy-oriented social media platform (React Native + Web + Node.js + Docker).<br />
		• Designed and deployed a fully containerized infrastructure for anonymous posting with encrypted user identities.<br />
		• Implemented geospatial MongoDB queries to enable proximity-based interactions without compromising user privacy.<br />
		• Experimented with moderation models for detecting harmful content and bot-like activity.<br />
		</li>

		<li>
		<strong>Chega Aí!</strong> — Mobile marketplace connecting local buyers and sellers.<br />
		• Built a complete cross-platform app using React Native, Expo Router, and Flask REST API backend.<br />
		• Implemented product filters, location-based recommendations, and real-time map visualization for vendors.<br />
		• Focused on UX design and state management optimization for fast, low-bandwidth usage on mobile devices.<br />
		</li>

		<li>
		<strong>Prantos</strong> — Full-stack ML system converting sheet music into audio.<br />
		• Designed a pipeline for symbolic-to-audio conversion using Optical Music Recognition (OMR) and generative models.<br />
		• Combined computer vision (sheet symbol detection) and audio synthesis networks (WaveNet) for polyphonic playback.<br />
		• Developed both the inference backend (Python + Torch + Flask) and a simple web interface for uploading scores.<br />
		</li>

		</ul>

		<p style={{ fontSize: '1.4em', fontWeight: 'bold' }}>Education</p>
		<p style={{ fontSize: '1.2em', fontWeight: 'bold' }}>Télécom SudParis – Institut Polytechnique de Paris</p>
		Master’s in Computer Vision focused on Image Processing and Neural Networks:<br />
		<ul>
		<li>Developed Transformer-Based models for brain tumor segmentation (BRATS dataset).</li>
		<li>Designed Siamese Neural Networks for facial recognition and GAN-based data augmentation.</li>
		<li>Built UNET architectures for liver and heart segmentation with MONAI.</li>
		<li>Finalist in the IPParis–Paris-Saclay Cancer Cluster Challenge (lung lesion segmentation).</li>
		</ul>

		<p style={{ fontSize: '1.2em', fontWeight: 'bold' }}>Federal University of Rio de Janeiro (UFRJ)</p>
		Bachelor’s in Electronics and Computer Engineering, focusing on AI, control, and embedded systems.<br />
		Participated in aerospace, robotics, and energy systems projects with emphasis on applied research.<br />

		<p style={{ fontSize: '1.4em', fontWeight: 'bold' }}>Languages</p>
		<ul>
		<li>English — C1 (TOEIC 965/990)</li>
		<li>French — B2 (TCF Tout Public)</li>
		<li>Spanish — A2</li>
		<li>Portuguese — Native</li>
		</ul>
	</>
	)
		},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible.",
		description:
			"Chronological collection of my long-form thoughts on the field of Artificial Intelligence. All the articles written here are also available on my Medium page: https://medium.com/@mathparracho",
	},

	projects: [

		{
			title: "Spiking Neural Networks: Towards Biologically Plausible Brain Models",
			description:
				"Spiking Neural Networks offer a biologically grounded alternative to conventional deep learning models. We explore their motivation, basic mechanisms, and relevance to brain-inspired computation.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/spiking-neural-networks-towards-biologically-plausible-brain-models-113cf2262204",
		},
		{
			title: "Signature Forgery Detection: Improving Cross-Dataset Generalization",
			description:
				"Thesis focused on developing robust deep learning systems for offline signature verification. The research introduces new strategies for improving cross-dataset generalization using contrastive learning, Siamese architectures, and handcrafted shell-based preprocessing techniques to detect forgeries across multiple datasets.",
			logo: "/arxiv-logomark.svg",
			linkText: "View Thesis",
			link: "https://arxiv.org/abs/2510.17724",
		},
		{
			title: "Learning Latent Permutations with Gumbel-Sinkhorn Networks",
			description:
				"In this article, I explore how to model latent permutations using Gumbel-Sinkhorn Networks, diving into the mathematical foundations, code implementation, and practical applications.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/learning-latent-permutations-with-gumbel-sinkhorn-networks-24e5ce3e4114",
		},
		{
			title: "At the Core of Transformer Architecture: From Attention to GPT",
			description:
				"I am going to study deeply into the attention mechanism. We’ll explore its mathematical foundations, walk through its code implementation, and see how it powers models like BERT and GPT.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/at-the-core-of-transformer-architecture-from-attention-to-gpt-deed149487cf",
		},
		{
			title: "Generating High-Resolution Images with PROGANs — Architecture Implementation and Analysis",
			description:
				"What if we wanted more resolution and more image fidelity? That is what NVIDIA researchers looked for in the PROGAN paper.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/generating-high-resolution-images-with-progans-architecture-implementation-and-analysis-98dfda26a06d",
		},
		{
			title: "Training an Agent to play Flappy Bird! (DQN Modelling — Reinforcement Learning)",
			description:
				"I am going to cover the mathematical foundations and all the pipelines using Pytorch to train and evaluate the model. In the end, the game will run amazingly!",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/training-an-agent-to-play-flappy-bird-dqn-modelling-reinforcement-learning-2cb16a9fa184",
		},
		{
			title: "Denoising Diffusion Probabilistic Models (DDPM) — Generative Intuition & Practice",
			description:
				"We will understand the interesting approach of Diffusion Models and why it is used in most of the SOTA generative models nowadays!",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/denoising-diffusion-probabilistic-models-ddpm-generative-intuition-practice-ef6b10d232a2",
		},
		{
			title: "Energy-Based Models and JEMs — Generative Intuition and Practice",
			description:
				"We will understand the power of modeling Energy-Based Models and explore why modeling a joint distribution a powerful idea. Also, JEMs!",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/energy-based-models-and-jems-generative-intuition-and-practice-8a69f1779188",
		},
		{
			title: "Generative Adversarial Networks (GANs, WGANs, WGANs-GP) — Generative Intuition & Practice",
			description:
				"In this second article, we are going to explore the mathematical foundations of GANs with Pytorch implementations from scratch.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/generative-adversarial-networks-gans-wgans-wgans-gp-generative-intuition-practice-24cb2dd43ed9",
		},
		{
			title: "Variational Autoencoders (VAEs, CVAEs, β-VAEs) — Generative Intuition & Practice",
			description:
				"We are going to explore one of the first ideas of modern generative models: the Variational Autoencoder. Big generative models nowadays, like OpenAI’s DALL·E, Google’s Imagen, and VAE-GANs are based on VAEs (more complex versions, of course, but VAE is the foundation)!",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/variational-autoencoders-vaes-cvaes-β-vaes-generative-intuition-practice-4b7b4011f55b",
		},
		{
			title: "Optimizing Siamese Convolutional Neural Networks: BCE x Contrastive x Triplet x Quadruplet Losses",
			description:
				"In this article, I explore four loss functions: Binary Cross-Entropy (BCE), Contrastive, Triplet, and Quadruplet. Finally, I analyze their impact on the model's overall performance using the MNIST dataset.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/optimizing-siamese-convolutional-neural-networks-bce-x-contrastive-x-triplet-x-quadruplet-losses-317922963ddc",
		},
		{
			title: "Skin Cancer Detection using Convolutional Neural Networks and Gradient Boosting Methods",
			description:
				"In this Medium article, I am going to explain step-by-step what were the ideas from my tentative and in the end we are going to make a comparison between the results from the CNN and the GBM.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/skin-cancer-detection-using-convolutional-neural-networks-and-gradient-boosting-methods-816c4cafc9f5",
		},
		{
			title: "Solving CAPTCHAs with Convolutional Neural Networks",
			description:
				"Developing a Convolutional Neural Network (CNN) to solve CAPTCHAs involves overcoming the challenges posed by noise, distortion, and anti-OCR techniques. This approach demonstrates how advanced AI can tackle complex recognition tasks, offering insights into data preparation, network architecture, and the potential of CNNs in automating previously unsolvable problems.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/solving-captchas-with-convolutional-neural-networks-89debcc65f55",
		},
		{
			title: "Heart Segmentation — Neural Networks for Medical Imaging",
			description:
				"This study provides insights into medical imaging segmentation by using MONAI and a 3D-UNET model to identify the left atrium in MRI heart volumes from the DECATHLON dataset. It addresses challenges like small data size and label imbalance, detailing the data preprocessing, model architecture, and training processes, highlighting the potential of deep learning in advancing medical image analysis.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/heart-segmentation-neural-networks-for-medical-imaging-a75138906ed1",
		},
		{
			title: "Autoencoders and Latent Space: Studying their power for data compression",
			description:
				"Autoencoders, a neural network architecture, have shown exceptional effectiveness in data compression by encoding data into a low-dimensional latent space. This article demonstrates the construction and training of a stacked autoencoder using the MNIST dataset, comparing the performance of different latent space dimensions, and highlighting the trade-off between data compression and reconstruction quality.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/autoencoders-and-latent-space-studying-their-power-for-data-compression-7f6b59d9694b",
		},
		{
			title: "Creating a Convolutional Neural Network to approach the MNIST dataset",
			description:
				"The MNIST dataset is already a well-known dataset to play around with different algorithms and try to score the highest possible score. The goal here is to predict what number is shown in the image using computer vision.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/creating-a-convolutional-neural-network-to-approach-the-mnist-dataset-9e80c210a89d",
		},
		{
			title: "Building the Infrastructure of a Social Mobile App: MaskUid",
			description:
				"MaskUid is an anonymous social media app designed to allow users to post within a 100-meter radius anonymously for 24 hours. Developed using React Native and hosted on GCP, the app focuses on the social dynamics of anonymous posting in local environments.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/maskuid-building-the-infrastructure-of-a-social-mobile-app-9e9d04f7b2d",
		},
		{
			title: "Prantos: Building a Full-Stack Web-Based Sheet Music to Audio Converter",
			description:
				"PRANTOS is a web system integrating deep learning for Optical Music Recognition (OMR) to convert music sheet images into GUIDO and WAV files. This project, developed using Flask for the backend and React for the frontend, demonstrates the application of machine learning in image processing, providing a user-friendly platform for music notation conversion and playback.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/prantos-building-a-full-stack-web-based-sheet-music-to-audio-converter-6243e5a11b23",
		},
		{
			title: "I built my own Alexa with some different features",
			description:
				"Built with ESP-32 modules, a custom WhatsApp API, and a Dockerized server, Axela manages various tasks through voice and text commands. This article outlines the development, communication protocols, and features of Axela, highlighting its potential to enhance everyday living through automation and smart technology integration.",
			logo: "https://www.svgrepo.com/show/354057/medium-icon.svg",
			linkText: "View Project",
			link: "https://medium.com/@mathparracho/i-built-my-own-alexa-with-different-features-ff22fa0f3d44",
		},
		{
			title: "PRANTOS - An Optimal Music Recognition System - IPParis Study Report",
			description:
				"PRANTOS is a web system integrating deep learning for Optical Music Recognition (OMR) to convert music sheet images into GUIDO and WAV files. This project, developed using Flask for the backend and React for the frontend, demonstrates the application of machine learning in image processing, providing a user-friendly platform for music notation conversion and playback.",
			logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg",
			linkText: "View Project",
			link: "https://drive.google.com/file/d/13Xf0mrMvZ7A2EJwmO5r2_vJHHtSasVOe/view?usp=sharing",
		},
		{
			title: "Image Encoding Methods - IPParis Study Report",
			description:
				"Studying the performance of different encoding techniques for imaging data",
			logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg",
			linkText: "View Project",
			link: "https://drive.google.com/file/d/1tC6znPe3ycotbPT0B4pKU8UyuKLakNdk/view?usp=sharing",
		},
		{
			title: "Morphological Segmentation - IPParis Study Report",
			description:
				"Studying different Morphological Segmentation tools applied in image processing",
			logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg",
			linkText: "View Project",
			link: "https://drive.google.com/file/d/1IQpAJ_OsiPrtr9rIPkbwLADxkMvNBHIr/view?usp=sharing",
		},
		{
			title: "SIFT Analysis for Imaging Feature Extraction - IPParis Study Report",
			description:
				"Studying the impact of applying SIFT for extracting features from images",
			logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg",
			linkText: "View Project",
			link: "https://drive.google.com/file/d/1Ka2E_36yaZCAGpTI5IND20yQNxLmDJ8R/view?usp=sharing",
		},
		{
			title: "Madrid Traffic Prediction - IPParis Study Report",
			description:
				"Analysing the madrid traffic prediction, proposing a solution and comparing it to state-of-the-art methods",
			logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg",
			linkText: "View Project",
			link: "https://drive.google.com/file/d/1otP5kAIWj4mDAFHI14v2qFJ2QX_1z_U7/view?usp=sharing",
		},
		{
			title: "Eigenfaces for Face Indexing and Recognition - IPParis Study Report",
			description:
				"Study of the “eigenfaces” face recognition algorithm based on PCA of the luminance face images.",
			logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg",
			linkText: "View Project",
			link: "https://drive.google.com/file/d/15JffQ0fO74_AqCM-bLQdIRYh-yVaHZAj/view?usp=sharing",
		},
		{
			title: "Shot Boundary Detection and Key-frame Extraction - IPParis Study Report",
			description:
				"Studying video analysis for shot boundary detection (abrupt or gradual transitions between scenes) and key-frame extraction focusing on selecting representative frames.",
			logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg",
			linkText: "View Project",
			link: "https://drive.google.com/file/d/18dCN8_oDu6g2FPhgxXk9aBiiOEd8vwMt/view?usp=sharing",
		},
		{
			title: "Combinatory and Sequential Logic - IPParis Study Report",
			description:
				"Study of logical gates for combinatory and sequential logic",
			logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg",
			linkText: "View Project",
			link: "https://drive.google.com/file/d/1Tp2M-PXnv6yiZN5JFVVJXW0JmEqfoj8v/view?usp=sharing",
		},
		{
			title: "Building Filters for Signal Processing - IPParis Study Report",
			description:
				"Study the architecture of filters to signal processing according to requirements",
			logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg",
			linkText: "View Project",
			link: "https://drive.google.com/file/d/1ByZu0KIlcjhhVvm3nv-ylpcpSHiPJ5EF/view?usp=sharing",
		},
	],
};

export default INFO;
